import { Grid, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import ReactCodeInput from "react-verification-code-input";
import {
  triggerEmailOtp,
  verifyEmailByOtp,
} from "../../../../../../../../features/post";
import AppModal from "../../../../../../modals/app-modal";
import { NotificationManager } from "react-notifications";

const EmailOTInputModal = ({
  account = {},
  visibility,
  handleClose,
  setDisplayOtpInputModal,
  setDisplayEmailInputModal,
  fetchAd,
}) => {
  const emailAddress = sessionStorage.getItem("pendingEmailAddress");
  const [otp, setOtp] = useState("");
  const [counter, setCounter] = useState(null);
  const [error, setError] = useState("");

  const triggerOtp = async () => {
    setError("");
    try {
      const data = {
        email: sessionStorage.getItem("pendingEmailAddress"),
        memberId: account.memberId,
      };
      const response = await triggerEmailOtp({ data });
      if (!response.success) {
        switch (response.body.code) {
          case 1201:
            setError("Too many attempts, Try again later");
            break;
          case 1108:
            setError("Email already in use");
            break;
          default:
            setError("Unknown error occurred");
            break;
        }
        return;
      }
      sessionStorage.setItem("emailUpdateToken", response.body.id);
      sessionStorage.setItem("pendingEmailAddress", response.body.sendTo);
      sessionStorage.setItem("emailUpdateRetryTime", response.body.retryIn);
      setCounter(response.body.retryIn);
      setDisplayEmailInputModal(false);
      setDisplayOtpInputModal(true);
    } catch (error) {
      console.log("Error >>>>", error);
    } finally {
    }
  };

  const onClickVerifyOtp = async () => {
    const data = {
      token: sessionStorage.getItem("emailUpdateToken"),
      otp,
      memberId: account.memberId,
    };
    try {
      const response = await verifyEmailByOtp({ data });
      if (!response.success) {
        switch (response.body.code) {
          case 1201:
            setError("Too many attempts, Try again later");
            break;
          case 1202:
            setError("Invalid Code");
            break;
          default:
            setError("Unknown error occurred");
            break;
        }
        setCounter(0);
        return;
      }
      fetchAd();
      setDisplayOtpInputModal(false);
      NotificationManager.success("Email Updated Successfully");
    } catch (error) {
      console.log("Error >>>", error);
    }
  };

  const displayEmailModal = () => {
    setDisplayOtpInputModal(false);
    setDisplayEmailInputModal(true);
  };

  useEffect(() => {
    const time = sessionStorage.getItem("emailUpdateRetryTime");
    setCounter(time);
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      counter > 0 && setCounter(counter - 1);
    }, 1000);
    counter === 0 && clearTimeout(timeout);

    return () => {
      clearTimeout(timeout);
    };
  }, [counter]);

  return (
    <AppModal
      visibility={visibility}
      handleClose={handleClose}
      title="Email Address Verification"
      secondaryLabel="Back"
      primaryLabel="Verify OTP"
      disablePrimaryAction={otp.length !== 6}
      onSecondaryAction={() => displayEmailModal()}
      onPrimaryAction={() => onClickVerifyOtp()}
    >
      <Grid
        container
        direction="column"
        alignItems="center"
        className="pb-16 gap-y-8"
      >
        <Typography variant="body2">Email Address</Typography>
        <Typography variant="body2" style={{ fontWeight: 600 }}>
          {emailAddress}
        </Typography>
        <Typography
          variant="caption"
          style={{ textDecoration: "underline", color: "#927001" }}
          onClick={() => displayEmailModal()}
        >
          Change
        </Typography>

        <ReactCodeInput
          type="number"
          fields={6}
          autocomplete="one-time-code"
          onChange={(e) => setOtp(e)}
        />

        {error && (
          <Typography variant="caption" style={{ color: "red" }}>
            {error}
          </Typography>
        )}

        <Typography variant="caption" style={{ marginTop: 8 }}>
          Didn't Receive OTP?
        </Typography>
        {counter > 0 && (
          <Typography variant="caption">{`Retry in ${counter}s`}</Typography>
        )}
        {counter === 0 && (
          <Typography
            variant="caption"
            style={{ textDecoration: "underline", color: "#927001" }}
            onClick={() => triggerOtp()}
          >
            Send Again
          </Typography>
        )}
      </Grid>
    </AppModal>
  );
};

export default EmailOTInputModal;
